import { styled } from "@mui/system";

export const StyledIconsContainer = styled("div")({
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
});
